import React from 'react';
import styled from 'styled-components';

const Level = ({ level }) => {
    const StyledLevel = styled.div`
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
    `;

    const Dot = styled.div`
        width: 8px;
        height: 8px;
        margin: 0 2px;
        border-radius: 50%;
        background-color: ${props => props.theme.palette.secondary[100]};
        
        &.schnoffle-level-active {
          background-color: ${props => props.theme.palette.secondary.main};
        } 
    `;

    const buildDots = () => {
        var Dots = [];
        for (var i = 0; i < 3; i++) {
            if (i < level) {
                Dots.push(<Dot key={i} className='schnoffle-level-active' />);
            }
            else {
                Dots.push(<Dot key={i} />);
            }
        }
        return Dots;
    };

    return (
        <StyledLevel>
            {buildDots()}
        </StyledLevel>
    );
};

export default Level;



// WEBPACK FOOTER //
// ./src/components/sewpat/Level.js